import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductPublishingStatusForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'product-publiserings-status', dataApiName: 'ProductPublishingStatus', text: 'Produkt publiseringsstatus',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, fieldMetadata: [
        { name: 'onix', text: 'ONIX' },
      ]
    });
  }
}
